import React, { useState } from "react";
import { BsXLg } from "react-icons/bs";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  InputAdornment,
} from "@mui/material";
import InputField from "./InputField";
import { IoSearchSharp } from "react-icons/io5";
import notFound from "../assets/notfound.png";
import axios from "axios";
import { SERVER_URL } from "../constant";
import userImg from "../assets/dp.jpg";
import { IoLocationOutline } from "react-icons/io5";
import { MdWorkOutline } from "react-icons/md";
import { MdOutlineMail } from "react-icons/md";

function EmployeeSearch({ trigger }) {
  const [open, setOpen] = useState(false);
  const [searchResult, setSearchResult] = useState(undefined);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // employee search
  async function searchEmployee() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/search/employees/${searchQuery}`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setSearchResult(res.data?.data);
    } catch (error) {
      console.log(error);
      setSearchResult([]);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <div onClick={handleOpen}>{trigger}</div>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth={"sm"}
        fullWidth={true}
      >
        <div>
          <section className="flex justify-between items-start">
            <section>
              <DialogTitle>Search Employees</DialogTitle>
            </section>
            <div className="px-[16px] py-[24px]">
              <BsXLg
                size={"17px"}
                onClick={handleClose}
                className="cursor-pointer"
              />
            </div>
          </section>
          <DialogContent>
            <div>
              <InputField
                label="Search"
                onChange={(eve) => setSearchQuery(eve?.target?.value)}
                slotProps={{
                  input: {
                    endAdornment: (
                      <InputAdornment position="start">
                        <section
                          className="flex gap-2 items-center bg-blue-500 px-5 py-2 rounded-lg cursor-pointer hover:shadow-lg"
                          onClick={searchEmployee}
                        >
                          <IoSearchSharp size={20} className="text-white" />
                          <p className="text-white">Search</p>
                        </section>
                      </InputAdornment>
                    ),
                  },
                }}
              />
              <div>
                {searchResult === undefined ? (
                  <>
                    <p className="text-center mt-5 text-slate-500">
                      Please search something
                    </p>
                  </>
                ) : Array.isArray(searchResult) &&
                  searchResult?.length === 0 ? (
                  <section className="flex justify-center items-center flex-col">
                    <section className="mt-5">
                      <img src={notFound} className="w-[7rem]" alt="" />
                      <p className="mt-3 text-slate-500">No collegue found</p>
                    </section>
                  </section>
                ) : (
                  <div className="mt-5 flex flex-col gap-3">
                    {searchResult?.map((data, i) => (
                      <section
                        className="bg-blue-50 p-3 rounded-lg flex items-start gap-3"
                        key={i}
                      >
                        <section className="w-[5rem] h-[5rem]">
                          {data?.logo ? (
                            <img
                              src={`${SERVER_URL}/api/v1/file/view/${data?.logo}`}
                              alt=""
                              className="w-full h-full object-cover rounded-full"
                            />
                          ) : (
                            <img
                              src={userImg}
                              className="w-full h-full object-cover rounded-full"
                            />
                          )}
                        </section>
                        <section>
                          <section className="mt-3">
                            <h2 className="text-slate-700 font-medium">
                              {data?.fullName}{" "}
                              <span className="bg-blue-100 px-3 py-1 rounded-full text-[14px] text-blue-600 ml-1 font-medium">
                                {data?.employeeId}
                              </span>
                            </h2>
                            <section className="mt-2">
                              <section className="flex items-center gap-5">
                                <section className="flex items-center gap-1">
                                  <IoLocationOutline
                                    size={18}
                                    className="text-slate-500"
                                  />
                                  <p className="text-[15px] text-slate-500">
                                    {data?.city}, {data?.country}
                                  </p>
                                </section>
                                <section className="flex items-center gap-1">
                                  <MdWorkOutline
                                    size={18}
                                    className="text-slate-500"
                                  />
                                  <p className="text-[15px] text-slate-500">
                                    {data?.role}
                                  </p>
                                </section>
                              </section>
                              <section className="mt-1">
                                <section className="flex items-center gap-1">
                                  <MdOutlineMail
                                    size={18}
                                    className="text-slate-500"
                                  />
                                  <p className="text-[15px] text-slate-500">
                                    {data?.gmail}
                                  </p>
                                </section>
                              </section>
                            </section>
                          </section>
                        </section>
                      </section>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </DialogContent>
        </div>
      </Dialog>
    </>
  );
}

export default EmployeeSearch;
